var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heroSection',{attrs:{"typePage":"subHeroNoSearch"}}),_c('div',{},[_c('pro')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }